import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest} from '@angular/common/http';

@Injectable()

export class AuthInterceptor  implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let currentToken = localStorage.getItem('token');
    if (currentToken) {
        //let headers = new Headers({ 'Authorization': 'Bearer ' + currentToken });
        //const authReq = req.clone({headers: req.headers.set('Authorization',  'Bearer ' + currentToken)});
        req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${currentToken}`
            }
          });
        return next.handle(req);
    }
    return next.handle(req);
  }
}


// WEBPACK FOOTER //
// C:/Users/tormo/Documents/InterNova/Kunder/Mattilsynet/plvmWEB/webapp/src/_services/interceptor.http.ts